import { memo } from "react";
import "./DashboardHeadIcon.css";
import { useTypedSelector } from "../../hook/useTypedSelector";
import { useAuthQuery } from "../../store/query/auth";
import { FaCheck } from "react-icons/fa";
import { ImCancelCircle } from "react-icons/im";
import { RiPassPendingFill } from "react-icons/ri";

const DashboardHeadIcon = () => {
  const { user, token } = useTypedSelector((store) => store.appUser);

  const { data: auth } = useAuthQuery({
    token: token,
    acc_type: user?.account_type,
  });

  return (
    <div className="menu">
      <div className="widget-box">
        <h4>{user?.name}</h4>
        {auth?.data?.status === 2 ||
        auth?.data?.status === "2" ||
        user?.status === 2 ||
        user?.status === "2" ? (
          <div className="tooltip-icon bag" data-tooltip="ACTIVE">
            <FaCheck color="#fff" size={12} />
          </div>
        ) : auth?.data?.status === 4 ||
          auth?.data?.status === "4" ||
          user?.status === 4 ||
          user?.status === "4" ? (
          <div className="tooltip-icon" data-tooltip="INACTIVE">
            <ImCancelCircle color="red" size={15} />
          </div>
        ) : (
          <div className="tooltip-icon pending" data-tooltip="PENDING">
            <RiPassPendingFill color="#fff" size={12} />
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(DashboardHeadIcon);
